import React from "react";
import { formatCompact } from "../../utils/formatCompact";
import {
  predictionLedgerSubline,
} from "../../users/userPredictionHelpers";
import PredictionsFixtureBlock from "./PredictionsFixtureBlock";

function predictionHeat(prediction, maxViews) {
  if (prediction.timing === "upcoming" || prediction.timing === "live") return 88;
  const views = Number(prediction.views) || 0;
  if (!maxViews) return 12;
  return Math.max(8, Math.round((views / maxViews) * 100));
}

export default function PredictionsFloorRow({ prediction, rank, selected, onSelect, heatPct }) {
  const isActive = prediction.timing === "upcoming" || prediction.timing === "live";

  return (
    <button
      type="button"
      className={`amf-row apr-row ${selected ? "amf-row-selected" : ""} ${isActive ? "amf-row-action" : ""}`}
      aria-pressed={selected}
      onClick={onSelect}
    >
      <span
        className="amf-row-heat"
        style={{ "--heat": `${heatPct}%` }}
        title={isActive ? "Active fixture" : "Engagement"}
        aria-hidden
      />
      <span className="amf-row-rank">{String(rank).padStart(2, "0")}</span>
      <span className="amf-row-body apr-row-body">
        <PredictionsFixtureBlock
          prediction={prediction}
          compact
          logoSize={22}
          className="apr-row-fixture"
          showPremiumBadge
        />
        <span className="amf-row-sub apr-row-sub">
          {predictionLedgerSubline(prediction, formatCompact)}
        </span>
      </span>
    </button>
  );
}

export { predictionHeat };
